<template>
    <div>
        <!-- 视频直播 -->
        <div :class="!isShowGallary?'':'hidden-video'">
            <div class="video-wrap">
                <div class="top-title mult_line_ellipsis" v-if="data.showTitle==='true'">{{data.title}}</div>
                <img v-if="data.liveType === 1 && data.status === 1" style="width:100%;height:100%" :src="data.imageUrl" alt>
                <video  
                        id="liveId"
                        v-else-if="data.liveType === 1 && data.status === 2"
                        :src="data.video"
                        :poster="data.image"
                        style="object-fit:fill" 
                        controlsList="nodownload"
                        x5-playsinline
                        playsinline
                        webkit-playsinline
                        x-webkit-airplay="true"
                        x5-video-player-type="h5"
                        controls
                        preload="auto"
                        x5-video-player-fullscreen="" 
                        x5-video-orientation="portraint"
                >
                </video>
                <video  
                        id="liveId"
                        v-else-if="data.liveType === 1 && data.status === 3 && data.playback"
                        :src="data.playback"
                        :poster="data.image"
                        style="object-fit:fill" 
                        controlsList="nodownload"
                        x5-playsinline
                        playsinline
                        webkit-playsinline
                        x-webkit-airplay="true"
                        x5-video-player-type="h5"
                        controls
                        preload="auto"
                        x5-video-player-fullscreen="" 
                        x5-video-orientation="portraint"
                >
                </video>
                <template v-else-if="data.liveType === 1 && data.status === 3 && !data.playback">
                    该直播已结束
                </template>
                <img style="width:100%;height:100%" v-else :src="data.image" alt>
            </div>
            <!-- 导航栏 -->
            <nav class="flex">
                <div @click="routerPush(index)" :class="{activeItem: activeIndex == index}" v-for="(li, index) in linkList" :key="index">
                    <span>{{li.name}}</span>
                </div>
                <div class="line"></div>
            </nav>

            <section>
                <!-- 直播间 -->
                <Room v-if="!activeIndex" @handleGallary = "handleGallary"></Room>

                <!-- 网友互动 -->
                <Interactive v-else @handleGallary = "handleGallary"></Interactive>

            </section>
        </div>
        <div v-if="isShowGallary" class="gallary-container" >
            <span class="closeBtn" @click="closeGallary">×</span>
            <img class="gallary-img" :src="gallaryImg" alt="">
        </div>
    </div>
</template>

<script>
import Room from './live2/live-room'
import Interactive from './live2/interactive'
import wx from "../services/weChatShare";
import { intfc_prefix_common } from 'constants/project'
import { Toast } from 'mint-ui'
// import editPng from '_images/btn_bottom_edit.png'
export default {
    data () {
        return {
            // editPng,
            data: {},
            activeIndex: 0,
            linkList: [
                {name:'直播间'},
                {name:'网友互动'}
            ],
            isShowGallary: false,
            gallaryImg:''
        }
    },

    created () {
        let id = this.$route.params.id
        this.getInit(id)
    },
    mounted() {
    },

    updated() {
        this.audioNewEvent()
    },

    methods: {
        routerPush (index) {
            this.activeIndex = index
        },

        getInit (articleId) {
            this.$axios.get(`${intfc_prefix_common}/api/v2/live/detail/${articleId}`)
                .then(res=> {
                    const result = res.item
                    if (res.code === 0) {
                        this.data = result

                        // 微信分享
                        let imgUrl = this.data.imageUrl
                        wx({
                            title: this.data.title,
                            // imgUrl: imgUrl,
                            // desc: this.data.description
                        },this)

                        // 存储唤醒的数据
                        // this.$store.dispatch('saveData', result)
                    }else {
                        Toast(res.msg)
                    }
                })
        },

        audioNewEvent() {
            var audios = document.getElementsByTagName("audio");
            var videos = document.getElementsByTagName("video");
            // 暂停函数
            function pauseAll() {
                var self = this;
                [].forEach.call(audios, function (i) {
                    // 将audios中其他的audio全部暂停
                    i !== self && i.pause();
                });
                [].forEach.call(videos, function (i) {
                    // 将audios中其他的audio全部暂停
                    i !== self && i.pause();
                })
            }
            
            // 给play事件绑定暂停函数
            [].forEach.call(videos, function (i) {
                i.addEventListener("play", pauseAll.bind(i));
            })
        },
        handleGallary(src){
            this.isShowGallary = true
            this.gallaryImg = src
        },
        closeGallary(){
            this.isShowGallary = false
            this.gallaryImg = ''
        }
    
    },

    components: {
        Room,
        Interactive
    }
}
</script>

<style lang="stylus" rel="stylesheet/stylus" scoped>
    @import "~src/stylus/mixin"
    .hidden-video
        display none
    .video-wrap
        position relative
        background #000
        width 100vw
        height 432px
        z-index 9999999
        color #fff
        font-size 32px
        text-align center
        line-height 432px
        .top-title
            position absolute
            top 0
            width 100%
            height 80px
            line-height 80px
            color #fff
            font-size 32px
            text-indent 40px
            background rgba(0, 0, 0, .2)
            z-index 10000
            text-align left
        video
            width 100%
            height 100%
            z-index 99999
    nav 
        position relative
        height 96px
        box-shadow 0px 10px 10px #f6f6f6
        .line
            position absolute
            left 50%
            top 50%
            margin -19px 0 0 -1px
            width 2px
            height 38px
            background #eee
        div 
            flex 1
            text-align center
            color #AAAAAA 
            font-size 28px
            line-height 96px
    section 
        overflow hidden
       .commentImg
           position fixed
           bottom 0
           right 20px
           img 
                width 140px
                height 140px
    .activeItem
        span 
            display inline-block
            color #C11531
            font-weight bold
            height 88px
            font-size 32px
            border-bottom 4px solid #C11531

.gallary-container
    display:flex;
    flex-direction: column;
    justify-content : center;
    z-index: 999999999;
    position: fixed;
    left: 0;
    right: 0;
    top: 0;
    bottom: 0;
    background-color: #000;
    .closeBtn
        position:absolute;
        top:20px;
        right:20px;
        color:#fff;
        font-size:48px;
        line-height:96px;
        width :100px;
        text-align:center;
    
    .gallary-img
        width: 100%;
        height: auto;
        max-height: 50%
           

</style>



// WEBPACK FOOTER //
// page-live2.vue?418ee4c4